/**
 * Wurde ein Inhalt wirklich GEHÖRT? (23.09.2026)
 *
 * Martin: *„Der Spiegel soll erst abgehakt sein, wenn ich ihn auch real
 * angehört habe."* Vorher galt: acht Sekunden offen = angesehen. Am Morgen
 * reichte ein kurzes Öffnen über die Kopfzeile, abgespielt wurde nichts.
 *
 * Gezählt wird nur, was wirklich lief: kleine Vorwärtsschritte der Position.
 * Ein Sprung im Schieber ist kein Zuhören, und der Wechsel in einen neuen
 * Abschnitt (Position fällt auf 0) auch nicht. Gemeldet wird EINMAL je
 * Inhalt — `neu()` stellt wieder scharf.
 */
interface Hoerzaehler {
  /** Aktuelle Abspielposition in Sekunden (aus dem Zeit-Takt des Players). */
  zeit(position: number): void;
  /** Das Ende des GANZEN Inhalts ist erreicht — zählt als gehört. */
  ende(): void;
  /** Neuer Inhalt: Zählung von vorn. */
  neu(): void;
}

/** Größter Schritt, der noch als Zuhören gilt (Takt des Players < 1 s). */
const HOECHSTER_SCHRITT = 2;

export function hoerzaehler(schwelleSek: number, onGehoert: () => void): Hoerzaehler {
  let gehoert = 0;
  let letzte = -1;
  let gemeldet = false;
  const melde = (): void => {
    if (gemeldet) return;
    gemeldet = true;
    onGehoert();
  };
  return {
    zeit(position: number): void {
      if (gemeldet || !Number.isFinite(position)) return;
      const schritt = position - letzte;
      if (letzte >= 0 && schritt > 0 && schritt < HOECHSTER_SCHRITT) gehoert += schritt;
      letzte = position;
      if (gehoert >= schwelleSek) melde();
    },
    ende(): void {
      melde();
    },
    neu(): void {
      gehoert = 0;
      letzte = -1;
      gemeldet = false;
    },
  };
}
